import { useSearchParams } from "react-router-dom";

export const useInvalidateCache = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const invalidate = () => {
        const draft = new URLSearchParams(searchParams);
        draft.set("t", Date.now().toString());
        setSearchParams(draft);
    };

    return invalidate;
};
